import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { AlertService } from '../../../../../../services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { UserTypology } from '../../../../../../models/enums/user-typology.model';
import { PaymentService } from '../../../../../../services/payment.service';
import { HTTP_CODES } from '../../../../../../models/enums/http-codes.enum';

@Component({
  templateUrl: './bary-modal-proceed-payment.html',
})
export class BaryProceedPaymentModalComponent implements OnInit {
  @ViewChild('paymentMethodExtra') paymentMethodExtra!: ElementRef;
  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public message: string | undefined;
  public icon: string | undefined;
  public class = '';
  public params!: any;
  public listUserTypology = UserTypology;
  public userTypology!: UserTypology;
  public hasSepaAlias!: boolean;
  public clicked: boolean = false;

  constructor(public modalRef: MDBModalRef, private jhiAlertService: AlertService, private translateService: TranslateService, private paymentService: PaymentService) {}

  public handleClick(from: any): void {
    const result = new BaryModalEvent(from);
    if (!this.clicked) {
      if (from.first) {
        if (
          [UserTypology.SEPA, UserTypology.OFFLINE, UserTypology.INIT_TRANSFERT_IMMEDIATE].includes(this.userTypology) ||
          (UserTypology.INIT_TRANSFERT_DEFERRED === this.userTypology && !this.params?.idBasketOrder)
        ) {
          this.clicked = true;
          this.paymentService.redirectPayment(this.userTypology).subscribe(httpResponse => {
            if (httpResponse.status !== HTTP_CODES.OK) {
              result.failure = true;
              result.first = false;
            } else {
              result.value = httpResponse.body;
            }
            this.action.next(result);
            this.modalRef.hide();
          });
        }
      } else {
        result.second = false;
        this.modalRef.hide();
      }
    }
  }

  ngOnInit(): void {
    if (
      [UserTypology.CB, UserTypology.INIT_TRANSFERT_IMMEDIATE].includes(this.userTypology) ||
      (this.userTypology === UserTypology.SEPA && !this.hasSepaAlias) ||
      (this.userTypology === UserTypology.INIT_TRANSFERT_DEFERRED && this.params.idBasketOrder)
    ) {
      this.paymentService.getPaymentForm(this.userTypology, this.params?.idBasketOrder).subscribe({
        next: (innerHTML: any): void => {
          this.paymentMethodExtra.nativeElement.innerHTML = innerHTML;
        },
        error: (err: any): void => {
          if (err.status === 406) {
            this.jhiAlertService.addAlert({
              type: 'danger',
              message: this.translateService.instant('baryApp.modal.errorConfig'),
            });
          }
        },
      });
    }
  }
}
